// This file is intentionally a single dynamic import rather than containing the
// app bootstrap logic directly.
//
// This app is a Module Federation remote — it can run either standalone (local
// development) or loaded inside the PLM container app at runtime. In both cases
// certain dependencies (e.g. @design-systems/canvas-ui) are declared as shared
// modules, meaning Module Federation needs to negotiate which version to use
// before any code that consumes those modules is allowed to execute.
//
// That negotiation happens asynchronously. If the app entry point imports
// consuming code directly (as a static import), webpack will try to execute it
// synchronously before the shared scope is ready — causing a runtime error:
//   "Shared module is not available for eager consumption"
//
// The fix is this async boundary: by making the entry point a dynamic import,
// webpack emits a separate async chunk for the real bootstrap code. The Module
// Federation runtime initializes the shared scope first, then the chunk loads —
// so all shared modules are resolved and available by the time any component
// code runs.
//
// When running standalone, webpack provides its own copy of each shared module.
// When running inside the container, the container's already-loaded copy is used
// instead. Either way, this file must stay as a bare dynamic import with no
// static imports of its own.
import('./bootstrap')
